import React, { useEffect } from "react";
import Icons from "../../assets/icons";
import callApi from "../../services/api/apiClient";
import { useSelector } from "react-redux";

const Dashboard = () => {
  const homeData = useSelector((state) => state?.home?.getHome?.data);

  const dashboard = [
    {
      name: "Warehouse",
      price: homeData?.warehouse,
      icon: Icons.warehouse,
      color: "bg-blue-2",
    },
    {
      name: "Products",
      price: homeData?.product,
      icon: Icons.product,
      color: "bg-green-2",
    },
    {
      name: "LiveSale Room",
      price: homeData?.livesaleroom,
      icon: Icons.liveSaleIcon,
      color: "bg-red-1",
    },
    {
      name: "Customers",
      price: homeData?.customer,
      icon: Icons.customerIcon,
      color: "bg-yellow-2",
    },
  ];

  useEffect(() => {
    getUserInfo();
    getHomeData();
  }, []);

  const getUserInfo = () => {
    callApi("user/profile").loadingGroup("HomePageLoading").executeDispatch();
  };

  const getHomeData = () => {
    callApi("home/getHome").loadingGroup("HomePageLoading").executeDispatch();
  };

  return (
    <>
      <div className="bg-gray-1 h-[calc(100vh-84px)] px-6 py-6">
        <h1 className="text-[24px] font-bold font-interRegular">
          Dashboard - Summary
        </h1>
        <div className="flex flex-wrap">
          {dashboard.map((item, index) => (
            <div
              key={index}
              className="rounded-[8px] w-[251px] h-[129px] bg-white-0 p-6 inline-flex mt-10 m-3"
            >
              <div
                className={`w-[69px] h-[69px] rounded-full ${item?.color} flex items-center justify-center`}
              >
                <img
                  src={item?.icon}
                  alt={item?.name}
                  className="w-[32px] h-[32px]"
                />
              </div>
              <div className="ml-6">
                <p className="font-interRegular text-lg">{item?.name}</p>
                <p className="text-[32px] text-blue-1 font-bold	">
                  {item?.price}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Dashboard;
